'use strict';

import './modules';

import './includes/initFeatherlight';

import './includes/initSlick';

import './includes/initSmoothScroll';
